<template>
  <div class="popup_base">
    <div class="popup" v-click-outside="closePopup">
      <div class="number_area">
        <TextBox
          v-for="(row, key) in inputNums"
          class="number"
          textClass="one_code"
          :key="key"
          maxlength="1"
          inputType="phone"
          placeholder=""
          @handleTextInput="codeChange($event, key)"
        />
      </div>
      <ErrorMessage
        v-if="errorMessage"
        class="error-message"
        :message="errorMessage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'SMSPopup',

  components: {
    TextBox,
    ErrorMessage,
  },

  data: () => ({
    errorMessage: '',
    inputNums: ['', '', '', '', '', ''],
  }),

  props: {
    tel: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      sendSMS: 'sms/sendSMS',
      checkSMS: 'sms/checkSMS',
    }),
  },

  watch: {
    sendSMS(newVal) {
      if (newVal.errors && newVal.errors.user_id) {
        alert(newVal.errors.user_id);
        this.closePopup();
      }
    },
    checkSMS(newVal) {
      this.errorMessage = '';
      if (newVal.state === 200) {
        this.$emit('success');
        return;
      }
      if (newVal.errors.sms_code) {
        this.errorMessage = newVal.errors.sms_code ? newVal.errors.sms_code[0] : '';
      }
    },
  },

  created() {
    const postParams = { tel: this.tel };
    this.$store.dispatch('sms/sendSMS', { postParams });
  },

  methods: {
    codeChange(value, code) {
      if (value !== '') {
        const ctrl = document.querySelectorAll('.number_area input');
        if (code < 5) {
          ctrl[code + 1].focus();
          ctrl[code + 1].select();
        }
      }
      this.inputNums[code] = value;

      let isInput = true;
      for (let i = 0; i < this.inputNums.length; i += 1) {
        if (this.inputNums[i] === '') {
          isInput = false;
        }
      }

      if (isInput) {
        let smsCode = '';
        for (let i = 0; i < this.inputNums.length; i += 1) {
          smsCode += `${this.inputNums[i]}`;
        }
        const postParams = { sms_code: smsCode };
        this.$store.dispatch('sms/checkSMS', { postParams });
      }
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup {
    background-color: white;
    padding: 60px;
    border-radius: 10px;
    .number_area {
      display: flex;
      .number {
        width: 60px;
        text-align: center;
        margin: 0 10px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .popup_base {
    .popup {
      padding: 20px;
      .number_area {
        .number {
          width: 40px;
          text-align: center;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
